import React from 'react';
import { MapPin, Box } from 'lucide-react';
import { useLanguage } from '../../../contexts/LanguageContext';
import './WarehouseCard.css';

export default function WarehouseCard({ warehouse, onEdit }) {
  const { t } = useLanguage();
  const {
    id,
    name,
    location,
    capacity,
    currentStock,
    incoming,
    outgoing,
    coordinates
  } = warehouse;

  // Calculate percentage safely, handling "N/A"
  const parsedCapacity = capacity === "N/A" ? 0 : capacity;
  const parsedStock = currentStock === "N/A" ? 0 : currentStock;
  const percentage = parsedCapacity > 0 ? (parsedStock / parsedCapacity) * 100 : 0;

  // Format percentage to 1 decimal place
  const formattedPercentage = capacity === "N/A" ? "N/A" : percentage.toFixed(1);

  // Determine dynamic color for progress bar
  // Example logic: < 60% = green, 60-80% = yellow/orange, > 80% = red
  let progressColorClass = 'progress-green';
  if (capacity === "N/A") {
    progressColorClass = 'progress-gray';
  } else if (percentage >= 60 && percentage < 85) {
    progressColorClass = 'progress-yellow';
  } else if (percentage >= 85) {
    progressColorClass = 'progress-red';
  }

  // Format coordinates (fallback if missing)
  const latFormat = coordinates?.lat ? `${coordinates.lat.toFixed(4)}° N` : '';
  const lngFormat = coordinates?.lng ? `${coordinates.lng.toFixed(4)}° E` : '';

  return (
      <div className="warehouse-card">
        <div className="warehouse-card-header">
          <div className="warehouse-info-container">
            <div className="warehouse-icon-wrapper">
              <Box size={24} color="#ffffff" className="warehouse-box-icon" />
            </div>
            <div className="warehouse-name-loc">
              <h3 className="warehouse-name">{name}</h3>
              <div className="warehouse-location">
                <MapPin size={14} className="warehouse-pin-icon" />
                <span>{location}</span>
              </div>
            </div>
          </div>
          <div className="warehouse-id-badge">{id}</div>
        </div>

        <div className="warehouse-storage-section">
          <div className="warehouse-storage-header">
            <span className="warehouse-storage-label">Storage Utilization</span>
            <span className="warehouse-storage-units">
            <span className="current-stock">{currentStock}</span> / {capacity} units
          </span>
          </div>

          <div className="warehouse-progress-container">
            <div
                className={`warehouse-progress-bar ${progressColorClass}`}
                style={{ width: `${percentage}%` }}
            ></div>
          </div>

          <div className="warehouse-storage-footer">
            {formattedPercentage}{formattedPercentage !== "N/A" && "% utilized"}
          </div>
        </div>

        <div className="warehouse-coordinates-section">
          <span className="coords-label">Coordinates</span>
          <div className="coords-value">
            {latFormat}, {lngFormat}
          </div>
        </div>
      </div>
  );
}
